<template>
  <div class="container-fluid py-4">
    <div class="row">
      <!-- Sidebar: Table of Contents -->
      <aside class="col-12 col-md-4 col-lg-3 mb-4">
        <div class="bg-light p-3 rounded shadow-sm sticky-top" style="top: 80px;">
          <h5 class="fw-bold">📚 Contents</h5>
          <ul class="list-unstyled">
            <li v-for="(section, index) in termsSections" :key="index" class="mb-2">
              <a :href="'#section-' + index" class="text-decoration-none d-flex align-items-center">
                <span class="me-2">📝</span>
                {{ section.title }}
              </a>
            </li>
          </ul>
        </div>
      </aside>

      <!-- Main Content -->
      <main class="col-12 col-md-8 col-lg-9">
        <div class="mb-4">
          <h1 class="display-6">📜 Terms & Conditions</h1>
          <p class="text-muted">
            🔄 Last Updated: <strong>{{ lastUpdated }}</strong>
          </p>
        </div>

        <div>
          <section
            v-for="(section, index) in termsSections"
            :key="index"
            :id="'section-' + index"
            class="mb-5"
          >
            <div class="d-flex align-items-center mb-3">
              <span class="me-2 fs-4">📌</span>
              <h2 class="h5 m-0">{{ section.title }}</h2>
            </div>
            <div class="ps-4" v-html="section.content"></div>
          </section>
        </div>

        <footer class="mt-5 border-top pt-3">
          <p class="text-muted">
            📬 Questions? Contact us at
            <a href="mailto:contact@wasiyah.com">contact@wasiyah.com</a>
          </p>
        </footer>
      </main>
    </div>
  </div>
</template>


<script>
export default {
  name: "TermsAndConditions",
  data() {
    return {
      lastUpdated: "May 7, 2025",
      termsSections: [
        {
          title: "General Terms",
          content: `
              <p>These Terms govern your use of Wasiyah.com ("Platform"). By accessing it, you agree to these Terms and our <a href="privacy-policy">Privacy Policy</a>.</p>
              <p>All registration information you submit will be true, accurate, current, and complete.</p>
              <p>You will not use the Services for any illegal or unauthorized purpose.</p>
              <p>Your use of the Services will not violate any applicable law or regulation.</p>
              <p>You will not create accounts through unauthorized means, including but not limited to, by using an automated device, script, bot, spider, crawler or scraper.</p>
              <p>You are solely responsible for your conduct and any data, text, files, information, usernames, images, graphics, photos, profiles, audio and video clips, sounds, musical works, events, works of authorship, applications, links and other content or materials (collectively, "Content") that you submit, post or display on or via our products.</p>
              <p>You must not interfere with or disrupt the service or servers or networks connected to the Services, including by transmitting any viruses, spyware, malware or any other code of a destructive or disruptive nature.</p>
            `,
        },
        {
          title: "Eligibility",
          content: `
      <p>Our services are intended for users who are at least <b>18</b> years old. By using Wasiyah.com, you represent and warrant that you meet this age requirement and have the legal capacity to enter into a binding agreement.</p>
    `,
        },
        {
          title: "Account Registration",
          content: `
              <p>To access certain features, you may be required to register for an account. You agree to:</p>
      <ul>
        <li>Provide accurate, current, and complete information during the registration process.</li>
        <li>Maintain and promptly update your account information to keep it accurate and complete.</li>
        <li>Maintain the security of your password and accept all risks of unauthorized access to your account.</li>
        <li>Notify us immediately of any unauthorized use of your account.</li>
      </ul>
            `,
        },
        {
          title: "Use of the Platform",
          content: `
              <p>You agree to use Wasiyah.com only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the platform. Prohibited behavior includes:</p>
      <ul>
        <li>Engaging in any unlawful or fraudulent activities.</li>
        <li>Transmitting any harmful, threatening, defamatory, obscene, or otherwise objectionable material.</li>
        <li>Interfering with the operation of the platform or accessing it using automated means.</li>
      </ul>
            `,
        },
        {
          title: "Zakat Calculation",
          content: `
              <p>The Zakat Calculator provided on Wasiyah.com is intended as a general guide based on Islamic principles. While we strive for accuracy, you are responsible for ensuring the correctness of your inputs and understanding that this tool does not constitute professional financial advice.</p>
    `,
        },
        {
          title: "Payments and Donations",
          content: `
              <p>All payments and donations made through Wasiyah.com are processed securely via third-party payment providers. You agree to provide accurate billing information and authorize us to charge your payment method for any transactions made. We are not responsible for any errors or issues arising from the payment process.</p>
    `,
        },
        {
          title: "Intellectual Property",
          content: `
              <p>All content on Wasiyah.com, including text, graphics, logos, and software, is the property of Wasiyah.com or its content suppliers and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works from any content without our express written permission.</p>
    `,
        },
        {
          title: "Limitation of Liability",
          content: `
              <p>We are not liable for indirect damages or inaccuracies in Zakat calculations. Always consult a scholar if in doubt.</p>
            `,
        },
        {
          title: "Termination",
          content: `
              <p>We reserve the right to suspend or terminate your access to Wasiyah.com at our sole discretion, without notice, for conduct that we believe violates these terms or is harmful to other users of the platform, us, or third parties, or for any other reason.</p>
    `,
        },
        {
          title: "Governing Law",
          content: `
              <p>These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction in which Wasiyah.com operates. You agree to submit to the exclusive jurisdiction of the courts located within that jurisdiction.</p>
    `,
        },
        {
          title: "Modifications to Terms",
          content: `
              <p>We may revise these terms and conditions at any time without prior notice. By continuing to use Wasiyah.com after any changes are made, you agree to be bound by the revised terms. It is your responsibility to review these terms periodically.</p>
    `,
        },
      ],
    };
  },
};
</script>

<style scoped>
.terms-container {
  display: flex;
  gap: 2rem;
  padding: 2rem;
  font-family: "Inter", sans-serif;
  background-color: #fafafa;
}

.toc ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.toc li {
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
}

.toc a {
  text-decoration: none;
  color: #1f2937;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: color 0.2s ease-in-out;
  padding: 0.35rem 0.5rem;
  border-radius: 8px;
}

.toc a:hover {
  background-color: #f3f4f6;
  color: #1e40af;
}

.toc-icon {
  font-size: 1rem;
  background-color: #e0f2fe;
  color: #0284c7;
  padding: 0.35rem;
  border-radius: 50%;
  display: inline-block;
  width: 1.8rem;
  height: 1.8rem;
  text-align: center;
  line-height: 1.1rem;
}

.terms-content {
  flex: 1;
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.terms-header {
  background: #f0f9ff;
  padding: 2rem;
  border-radius: 1rem;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.terms-header h1 {
  font-size: 2rem;
  color: #1e3a8a;
  margin-bottom: 0.5rem;
}

.terms-header .updated {
  font-size: 0.95rem;
  color: #6b7280;
}

.terms-section {
  background: #ffffff;
  padding: 2rem;
  margin-top: 2rem;
  border-radius: 1rem;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.06);
}

.section-badge {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.section-icon {
  font-size: 1.5rem;
  background-color: #e0f2fe;
  color: #0284c7;
  padding: 0.75rem;
  border-radius: 50%;
  display: inline-block;
  width: 3rem;
  height: 3rem;
  text-align: center;
  line-height: 1.5rem;
}

.terms-section h2 {
  font-size: 1.4rem;
  color: #0f172a;
  margin: 0;
}

/* .section-content {
  font-size: 1rem;
  color: #374151;
  line-height: 1.7;
} */
.terms-wrapper {
  max-width: 800px; /* Optional: for readability */
  margin: 0 auto;
  padding: 20px;
  text-align: left; /* Ensure left alignment globally */
}

.section-content p,
.section-content ul,
.section-content li {
  text-align: left;
  line-height: 1.6;
  font-size: 15px;
  color: #374151;
  margin: 6px 0;
}
.terms-footer {
  text-align: center;
  margin-top: 3rem;
  font-size: 0.95rem;
  color: #6b7280;
}
</style>
